import React from 'react';
import '../../../css/ProfileManagement/ProfileActivity.css';
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';
import { baseURL } from '../../../Services/config/apiGateway';
import { PROFILE_ACTIVITY_ENDPOINT } from '../../../Services/config/apiEndPoints';
import { ApiCall } from '../../../Services/utils/ApiCall';
import { AES, enc } from 'crypto-js';
import { connect } from 'react-redux';


class ProfileActivity extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ProfileActivityData: [],
            activityTime : [],
             activityDate : []
           
        }
    }
    componentDidMount() {
        const { profileType } = this.props.match.params;
        ApiCall(
            'GET',
            baseURL + PROFILE_ACTIVITY_ENDPOINT + `?userId=${this.props.userProfileDataR?.userId}&userProfileType=${profileType}`,
            {},
            {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        ).then((apiData) => {
            if (apiData.flag != -1) {
                if (apiData.flag == '500') {
                    console.log('I am 500!');
                } else {
                    console.log('I am 200!');
                    this.setState({ ProfileActivityData: apiData });
                    this.getDate(apiData);
                    this.getTime(apiData);
                }
            } else {
                console.log('Something went wrong!');
            }
        });
    }
    getTime = (apiData) => {
        console.log("get Time funn")
        let time='';
        apiData?.map((data)=>{
            if(data?.approvalDate){
                time = new Date(data?.approvalDate)?.toString()?.split(' ')[4]?.substring(0, 5);
            }
            else if(data?.profileSubmissionDate){
                time = new Date(data?.profileSubmissionDate)?.toString()?.split(' ')[4]?.substring(0, 5);
            }
            this.state.activityTime.push(time);
        });
    }
    getDate = (apiData) => {
        console.log("get Date funn")

        apiData?.map((data)=>{
            let date ='';
            if(data?.approvalDate){
             date = new Date(data?.approvalDate)?.toGMTString();
            }else if(data?.profileSubmissionDate){
                date = new Date(data?.profileSubmissionDate)?.toGMTString();
            }
            let day = date?.split(' ')[1];
            let month = date?.split(' ')[2];
            let year = date?.split(' ')[3];
            this.state.activityDate?.push(`${day}-${month}-${year}`);
        })
       
    }
    render() {
        return (
            <div>
                <div>
                    <MetaDecorator title={TitleDescription.profileActivityTitle} description={TitleDescription.profileActivityDescription} />
                    <Header tilesFetched={() => { }} />
                    <div class="proactfull">
                        <div>
                            <div class="profileActivityupNav">
                                <div class="pa01">
                                    <small class="" id="profileActivitytext">Profile Activity</small>
                                </div>
                            </div>
                            <hr class="hr1" />
                            <div className="profileActivitySection">
                                <div className="groupCard">
                                    {this.state.ProfileActivityData?.reverse()?.map((name, index) =>
                                        <div>
                                            {name.approvalStatus != "Submitted" &&
                                                <div className="activitycard1">
                                                    <div className="card1part1">
                                                        <div className="approvedDiv">
                                                            <small className="approved" style={{ color: name.approvalStatus === "Rejected" ? "#D42E12" : "#199D00" }} >
                                                                {name.approvalStatus}</small></div>
                                                        <div className="rightPart"><small className="datetime">{this.state.activityDate[index]}</small>
                                                            <small className="datetime">{this.state.activityTime[index]}</small></div>
                                                    </div> <hr className="cardhr" />
                                                    <div className="card1part2">
                                                        <small className="comment">Comments</small>
                                                        <small className="ok">{name.comments}</small>
                                                    </div>
                                                </div>
                                            }
                                            {name.approvalStatus === "Submitted" &&
                                                <div className="activityCard2">
                                                    <div className="leftpart"><small className="card2Text">Submitted for Approval</small></div>
                                                    <div className="rightPartcard2"><small className="datetime">{this.state.activityDate[index]}</small>
                                                        <small className="datetime">{this.state.activityTime[index]}</small></div>
                                                </div>
                                            }
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        );
    }
}
function mapStateToProps(state) {
    if (state.userProfileInfoReducer.data) {
        return {
            userProfileDataR: JSON.parse(AES.decrypt(state.userProfileInfoReducer.data, 'TPT_CARGO_CONNECT').toString(enc.Utf8))
        }
    }
}
export default connect(mapStateToProps)(ProfileActivity);
